var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddBankIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 14H19V17H22V19H19V22H17V19H14V17H17V14ZM11.5 1L21 6V8H2V6L11.5 1ZM16 10H19V12.08L18 12C17.3 12 16.63 12.12 16 12.34V10ZM2 22V19H12.08C12.27 20.14 12.79 21.17 13.53 22H2ZM10 10H13V14.68C12.54 15.37 12.22 16.15 12.08 17H10V10ZM4 10H7V17H4V10Z",
    fill: "#49454F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddBankIcon);
export default __webpack_public_path__ + "static/media/addBank_icon.625d7f63e21c97940384cf43a125f89a.svg";
export { ForwardRef as ReactComponent };